/** @format */
import { Component, inject, ViewEncapsulation } from '@angular/core';
import { StateService } from '@uirouter/core';

@Component({
    selector: 'app-study-right-extension-workflow-payment-processing',
    templateUrl: './study-right-extension-workflow-payment-processing.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: false,
})
export class StudyRightExtensionWorkflowPaymentProcessingComponent {
    private readonly state = inject(StateService);

    goToApplications() {
        this.state.go('student.logged-in.profile.applications');
    }
}
